module.exports = __webpack_public_path__ + "img/identifyLoding.c7f40590.png";